import React, { Component } from 'react'
import { pure } from 'recompose'
import Pro from './../components/Pro/'
import { API_HOST } from './../config'

const loadPro = async (id) => {
    if(!id){
        throw new Error('You must provide id')
    }
    return fetch(`${API_HOST}/pros/${id}`)
        .then(res => {
            if(!res.ok){
                throw new Error(res)
            }
            return res
        })
        .then(res => res.json())
}
/*
const createCalendar = async (data) => {
    if (!data){
        throw new Error('You must provide data')
    }
    return fetch(`${API_HOST}/calendar`, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: data
    }).then(res => {
        if (!res.ok) {
            throw new Error(res)
        }
        return res
    })
    .then(res => res.json())
}*/
/**
 * 
 * {
               "first_name":"John",
               "last_name":"Doe",
               "email":"test@setster.com",
               "public_email":1,
               "phone":123123123,
               "can_login":true,
               "password":"*****",
               "send_invite_email":false,
               "status":1,
               "job":"test",
               "nickname":"testnickname",
               "links":[]
            }} param0
 */

const CreateForm = ({data, onSubmit}) => {
    const { firstname, lastname, email} = data
    return(
        <form onSubmit={onSubmit}>
            <div className="form-group">
                <label htmlFor="first_name">First name</label><br />
                <input type="text" id="first_name" name="first_name" value={firstname} />
            </div>
            <div className="form-group">
                <label htmlFor="last_name">Last name</label><br />
                <input type="text" id="last_name" name="last_name" value={lastname} />
            </div>
            <div className="form-group">
                <label htmlFor="email">Email</label><br />
                <input type="email" id="email" name="email" value={email} />
            </div>
            <div className="form-group">
                <label htmlFor="password">Password</label><br />
                <input type="password" id="password" name="password" />
            </div>
            <div className="form-group">
                <button className="button">Submit</button>
            </div>
        </form>
    )
}


class ProPage extends Component{

    constructor(props){
        super(props)
        this.state = {
            loading: true,
            error: false,
            pros: [],
            createMode: false,
            createId: null
        }
    }

    async componentDidMount() {
        const { params: {id} } = this.props.match
        try {
            const pros = await loadPro(id)
            this.setState({
                pros: pros,
                error: false,
                loading: false,
            })
        } catch (error) {
            this.setState({
                pros: [],
                error: true,
                loading: false,
            })
        }
    }

    async createSetsterAccount(event, data){
        event.preventDefault()
        console.log(data)
    }

    toggleCreateMode = (event, id) => {
        event.preventDefault()
        this.setState({
            createMode: !this.state.createMode,
            createId: id
        })
    }
    
    render(){
        const { loading, pros = [], createMode, createId } = this.state
        
        if (loading){
            return loading && <p className="text--loading">Loading</p>
        }

        return (
            <div className="pro">
                
                {
                    pros.map(p => (
                        [
                            createMode && createId === p.id && <CreateForm data={p} onSubmit={event => this.createSetsterAccount(event)} />,
                        !createMode && createId !== p.id && <p key={`button-${p.id}`}>
                            <button onClick={event => this.toggleCreateMode(event, p.id)} className="button" href="#">
                                Create Setster employee
                            </button>
                        </p>,
                        <Pro 
                            data={p} 
                            key={p.id}
                        />

                        ]
                    ))
                }
            </div>
        )    
    }
}

export default pure(ProPage)


// WEBPACK FOOTER //
// ./src/pages/Pro.js